import React, { Fragment } from 'react';
import Container from '../../../../constants/Container';
import { formatMoney_2 } from '../../../../helpers/DateFormat';

interface DayBookRptProps {
    onDayBookReport: any
}
const DayBookListView: React.FC<DayBookRptProps> = ({ onDayBookReport }) => {
    // Column totals
    const totals = {
        tariff: 0,
        fine: 0,
        pipe: 0,
        advance: 0,
        nameExchange: 0,
        connection: 0,
        renew: 0,
        meter: 0,
        bibidh: 0,
        other: 0,
        totalAmount: 0,
        discount: 0,
        netAmount: 0,
    };

    if (Array.isArray(onDayBookReport?.results)) {
        onDayBookReport.results.forEach((item: any) => {
            const tariff = item?.incomereveiced || 0;
            const fine = item?.fineamount || 0;
            const pipe = item?.pipeandfitting || 0;
            const advance = item?.advanceamountcollect || 0;
            const nameExchange = item?.namsarisulka || 0;
            const connection = item?.dharajadanshulka || 0;
            const renew = item?.renewalcharge || 0;
            const meter = item?.metercharge || 0;
            const bibidh = item?.bibidh || 0;
            const other = item?.anya || 0;
            const discount = item?.discountamount || 0;

            const total = tariff + fine + pipe + advance + nameExchange + connection + renew + meter + bibidh + other;
            const net = total - discount;

            totals.tariff += tariff;
            totals.fine += fine;
            totals.pipe += pipe;
            totals.advance += advance;
            totals.nameExchange += nameExchange;
            totals.connection += connection;
            totals.renew += renew;
            totals.meter += meter;
            totals.bibidh += bibidh;
            totals.other += other;
            totals.totalAmount += total;
            totals.discount += discount;
            totals.netAmount += net;
        });
    }

    return (
        <Fragment>
            <Container padding>
                <div className="relative overflow-x-auto">
                    <table className="text-sm text-left rtl:text-right text-sky-900 whitespace-nowrap scroll-x-auto dark:text-slate-400 rounded w-full">
                        <thead className="text-[12px] text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400 font-public-sans">
                            <tr>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-10">
                                    S.N.
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800">
                                    Member Name
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Receipt No.
                                </th>

                                <th scope="col" colSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Tarriff
                                </th>
                                <th scope="col" colSpan={8} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Other Income
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Total
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Discount
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Net Amount
                                </th>
                            </tr>
                            <tr>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Tariff
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Fine
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Pipe & Fitting
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Advance Amount
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Name Exchange
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Connection Amt
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Renew
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Meter
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Bibidth
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Other
                                </th>
                            </tr>
                        </thead>
                        <tbody className='text-slate-800'>
                            {Array.isArray(onDayBookReport?.results) &&
                                onDayBookReport?.results?.map((item: any, index: number) => {

                                    const totalAmount =
                                        (item?.incomereveiced || 0) +
                                        (item?.fineamount || 0) +
                                        (item?.pipeandfitting || 0) +
                                        (item?.advanceamountcollect || 0) +
                                        (item?.namsarisulka || 0) +
                                        (item?.dharajadanshulka || 0) +
                                        (item?.renewalcharge || 0) +
                                        (item?.metercharge || 0) +
                                        (item?.bibidh || 0) +
                                        (item?.anya || 0);
                                    const netAmount = totalAmount - (item?.discountamount || 0);
                                    return (
                                        <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                                            <td align='center' className="px-2 border border-gray-300 font-medium dark:border-sky-800 capitalize">
                                                {index + 1}.
                                            </td>
                                            <td align='left' className="px-2 border border-gray-300 font-medium dark:border-sky-800 capitalize">
                                                {`${item?.memname}`}
                                            </td>
                                            <td align='center' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]">
                                                {item.billingno}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.incomereveiced || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.fineamount || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.pipeandfitting || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.advanceamountcollect || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.namsarisulka || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.dharajadanshulka || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.renewalcharge || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.metercharge || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.bibidh || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.anya || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(totalAmount || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(item?.discountamount || 0)}
                                            </td>
                                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                                {formatMoney_2(netAmount || 0)}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            <tr className="font-semibold text-[12px] bg-slate-200 text-sky-900 dark:bg-sky-950 dark:text-slate-100">
                                <td colSpan={3} align='center' className="px-2 border border-slate-300 dark:border-sky-800">
                                    Total
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.tariff)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.fine)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.pipe)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.advance)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.nameExchange)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.connection)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.renew)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.meter)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.bibidh)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.other)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.totalAmount)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.discount)}
                                </td>
                                <td align='right' className="px-2 border border-slate-300 dark:border-sky-800">
                                    {formatMoney_2(totals.netAmount)}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </Container>
        </Fragment>
    )
}

export default DayBookListView